import { getTXRoofSurfacesExtended } from '@ourbranch/roof-helpers';

export const txRoofSurfacesExtendedHelper = (roofAge, deductibleWindHail, coverageRSExtended) => {
  return getTXRoofSurfacesExtended(roofAge, deductibleWindHail, coverageRSExtended);
};
